module.exports = __webpack_public_path__ + "img/11.a3eeb69b.svg";